import { render, staticRenderFns } from "./AddSupplementsItem.vue?vue&type=template&id=ccff32aa&scoped=true"
import script from "./AddSupplementsItem.vue?vue&type=script&lang=js"
export * from "./AddSupplementsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccff32aa",
  null
  
)

export default component.exports